module.exports = __webpack_public_path__ + "img/product-5-AGP.d9dd35d4.png";